import React, { PureComponent } from 'react';
import { Flex } from '../../common/Flex';
import { CaretRightOutlined } from '@ant-design/icons';
import './DeltaTvImpact.less';
import { CountType, LoadClassification } from '../../../model/CORE';
import { NIATvImpact } from '../../../model/SOL49';
import { Divider } from 'antd';

interface DeltaTvImpactProps {
    deltaTvImpacts: NIATvImpact[];
}

type delta = 'BEFORE' | 'AFTER';

type DeltaAlerts = Record<LoadClassification, Record<delta, number>>;

const getDeltaAlerts = (tvImpacts: NIATvImpact[]): DeltaAlerts => ({
    COLD: undefined,
    LOW_THRESHOLD: {
        BEFORE: tvImpacts?.filter(tvImpact => tvImpact.loadBefore === LoadClassification.LOW_THRESHOLD).length,
        AFTER: tvImpacts?.filter(tvImpact => tvImpact.loadAfter === LoadClassification.LOW_THRESHOLD).length,
    },
    NORMAL: undefined,
    OVERLOAD: {
        BEFORE: tvImpacts?.filter(tvImpact => tvImpact.loadBefore === LoadClassification.OVERLOAD).length,
        AFTER: tvImpacts?.filter(tvImpact => tvImpact.loadAfter === LoadClassification.OVERLOAD).length,
    },
    UNDEFINED: undefined,
    HIGH_THRESHOLD: {
        BEFORE: tvImpacts?.filter(tvImpact => tvImpact.loadBefore === LoadClassification.HIGH_THRESHOLD).length,
        AFTER: tvImpacts?.filter(tvImpact => tvImpact.loadAfter === LoadClassification.HIGH_THRESHOLD).length,
    },
});

export class DeltaTvImpact extends PureComponent<DeltaTvImpactProps> {
    render() {
        const occupancyTvImpact = this.props.deltaTvImpacts?.filter(tv => tv.countType === CountType.OCCUPANCY);
        const entryTvImpact = this.props.deltaTvImpacts?.filter(tv => tv.countType === CountType.ENTRY);

        return (
            <Flex direction="vertical" className="delta-tv-impact">
                <Flex className="header" grow={false} size="2em">
                    IMPACT ON OTHER TFVs
                </Flex>
                <Flex grow={false}>
                    <TvImpactDeltaForCountType countType={CountType.OCCUPANCY} tvImpactDelta={occupancyTvImpact} />
                    <Flex grow={false} className="divider-container">
                        <Divider type="vertical" className="divider" />
                    </Flex>
                    <TvImpactDeltaForCountType countType={CountType.ENTRY} tvImpactDelta={entryTvImpact} />
                </Flex>
            </Flex>
        );
    }
}

interface TvImpactDeltaForCountTypeProps {
    countType: CountType;
    tvImpactDelta: NIATvImpact[];
}

class TvImpactDeltaForCountType extends PureComponent<TvImpactDeltaForCountTypeProps> {
    render() {
        const deltas = getDeltaAlerts(this.props.tvImpactDelta);
        return (
            <Flex direction="vertical" grow={false}>
                <Flex grow={false} className="count-type">
                    {this.props.countType}
                </Flex>
                <Flex style={{ padding: '0.5em' }}>
                    <Flex direction="vertical">
                        <Flex direction="vertical" className="container" size="5em">
                            <Flex className="overload">{deltas.OVERLOAD.BEFORE}</Flex>
                            <Flex className="high-threshold">{deltas.HIGH_THRESHOLD.BEFORE}</Flex>
                            <Flex className="low-threshold">{deltas.LOW_THRESHOLD.BEFORE}</Flex>
                        </Flex>
                    </Flex>
                    <Flex className="arrow">
                        <CaretRightOutlined />
                    </Flex>
                    <Flex direction="vertical">
                        <Flex direction="vertical" className="container" size="5em">
                            <Flex className="overload">{deltas.OVERLOAD.AFTER}</Flex>
                            <Flex className="high-threshold">{deltas.HIGH_THRESHOLD.AFTER}</Flex>
                            <Flex className="low-threshold">{deltas.LOW_THRESHOLD.AFTER}</Flex>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        );
    }
}
